import m from "../../node_modules/classnames/index.js";
import { jsx as i } from "../../_virtual/jsx-runtime.js";
function a({
  className: o,
  children: r
}) {
  return /* @__PURE__ */ i("div", {
    className: m("form-grid__action", o),
    children: r
  });
}
export {
  a as FormAction
};
//# sourceMappingURL=FormAction.js.map
